module.exports = __webpack_public_path__ + "static/media/ecertchile.88a5f11d.png";